export default __webpack_public_path__ + "static/layout-anatomy-dark-d30162e593807ff7dbcb77f4ffcc2d7e7348b9dea61381fdf4a61a121d70edfb.png";